import water_tap from "../../Assets/Images/water-tap.gif";
import toilet_bowl from "../../Assets/Images/toilet-bowl.gif";
import survey_dashboard from "../../Assets/Images/survey_dashboard.png";
import newsItem from "../../Assets/Images/newsItem.png";
import tank from "../../Assets/Images/tank.jpg";
import NewsSlider from "../../Components/Home/NewsSlider";
import FAQ from "../../Components/Home/FAQ.js";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className=" w-full h-full  text-[#2F4B7C] bangla-font">
      <div className="relative   w-full ">
        <div className=" flex gap-4 items-center justify-center mx-auto w-[40%] md:w-[25%] lg:w-[20%] max-w-lg">
          <img src={toilet_bowl} alt="water-tap" />
          <img src={water_tap} alt="toilet-pan" />
        </div>
        <div className=" text-center w-full">
          <h2 className="px-[10%] md:px-[25%] lg:px-[20%] text-[36px] md:text-[40px] lg:text-[52px] font-bold leading-10 md:leading-8 lg:leading-normal pb-4 lg:pb-0 pt-8 lg:pt-0">
            {t(`new_home.title`)}
          </h2>
          <p className="px-[20%] tablet:[22%] large:px-[25%]   py-2 md:py-0 text-[14px] sm:text-[16px] md:text-[18px] lg:text-[24px] leading-5 md:leading-8">
            {t("new_home.subtitle")}
          </p>
        </div>
        <div className="mt-10 lg:pt-0 bottom-28 left-0  w-full">
          <img className="w-full " src="/images/bg-colored.svg" alt="background-art" />
        </div>
      </div>

      <div className=" w-full mt-8 ">
        <div className="text-[#2F4B7C] text-center w-full space-y-4">
          <div className="mb-24 tablet:mb-28 large:mb-40">
            <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold ">
              {t("new_home.city_profile_and_city_comparison")}
            </h2>
            <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
              {t("new_home.city_profile_and_city_comparison_sub")}
            </p>
          </div>

          <div className="relative ">
            <img
              className="absolute -z-10 -top-[40%] w-[35%]"
              src="/images/desludger.svg"
              alt="desludger"
            />
            <img
              src="/images/dashboard.svg"
              alt="dashboard"
              className="w-[75%] mx-auto max-w-6xl"
            />
          </div>
        </div>
      </div>

      <div className="w-full mt-8">
        <img
          src="/images/vacutag.svg"
          className="w-1/2 ml-auto translate-y-2 -z-50 max-w-2xl 2xl:ml-[50%]"
        />
        <div className="max-w-3xl bg-[#2F4B7C] text-white w-[75%] mx-auto space-y-4 z-10 relative large:flex gap-6 h-[100%]">
          <img
            src="/images/charts.svg"
            className="-translate-y-2 large:w-[60%] large:absolute left-0 -top-36"
          />
          <div className="text-[20px] font-bold pb-8 large:text-left large:ml-auto large:mr-[10%]">
            <p>{t("new_home.sankey_diagram")}</p>
            <p>{t("new_home.sunburst_diagram")}</p>
            <p>
              <span className="font-normal mr-2">{t("new_home.and")}</span>
              {t("new_home.shit_flow_diagram")}
            </p>
            <p className="text-[15px]">
              
              {t("new_home.to_dive_deeper_into_the_insights")}
            </p>
          </div>
        </div>
      </div>

      <div className=" w-full mt-20">
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.Key_indicators_analysis")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.Key_indicators_analysis_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src="/images/indicators.svg"
            alt="indicators"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
          <img
            src="/images/sit_dump.svg"
            alt="pooping and sitting"
            className="absolute right-0 top-[75%] w-[20%] -z-10"
          />
        </div>
      </div>

      <div className="w-full mt-20">
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.survey_management_and_monitoring")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.survey_management_and_monitoring_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src={survey_dashboard}
            alt="dashboard 2"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
        </div>
      </div>
      <div className="relative w-full mt-20">
        <img
          src={tank}
          className=" -z-10 absolute w-[38%] tablet:w-[35%] large:w-[32%] -left-6 tablet:-left-10 -top-20 tablet:-top-28 max-w-2xl"
        />
        <div>
          <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
            {t("new_home.create_manage_and_monitor_kii")}
          </h2>
          <p className="px-[10%] md:px-[25%] lg:px-[20%] pb-4 text-[15px] tablet:text-[18px] large:text-[24px] ">
            {t("new_home.create_manage_and_monitor_kii_sub")}
          </p>
        </div>
        <div className="relative">
          <img
            src="/images/data_collection_kii.svg"
            alt="data collection dashboard KII"
            className="w-[75%] mx-auto max-w-6xl bg-white"
          />
        </div>
      </div>

      <div className="w-full mt-20">
        <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
          {t("new_home.integrated_with_sub_national_and_national_platforms")}
        </h2>
        <img
          src="/images/imislogo.svg"
          className="mx-auto w-[55%] tablet:w-[35%] large:w-[30%]  py-8"
          alt=""
        />
        <h2 className="px-[15%]  tablet:px-[18%] large:px-[25%] text-[26px] tablet:text-[30px] large:text-[36px] font-bold">
          {t("new_home.imis")}
        </h2>
        <p className="text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] font-light opacity-65 w-[70%] tablet:w-[60%] large:w-[50%] mx-auto">
          {t("new_home.imis_sub")}
        </p>
      </div>

      <FAQ />

      <NewsSlider />
    </div>
  );
};

export default Home;
